import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ROUTES } from "../../../configs/routes";
import {
  TURKEY_COUNTRY_CODE,
  TURKEY_SA_COUNTRY_CODE,
} from "../../../constants/countryDefaults";
import { useHub } from "../../../hooks/hub-hooks";
import { useLayout } from "../../../hooks/layout-hooks";
import { useLoginOptionHooks } from "../../../hooks/login-option-hooks";
import { ApplicationState } from "../../../store";
import { LayoutState } from "../../../store/reducers/layout-reducer";
import { UserState } from "../../../store/reducers/user-reducer";
import { UtilsUser } from "../../../utils/UtilsUser";
import { Banner } from "./Sections/Banner/Banner";
import LearnMore from "./Sections/LearnMore/LearnMore";
import ManagePrivacy from "./Sections/ManagePrivacy/ManagePrivacy";
import PersonalDataManagement from "./Sections/PersonalDataManagement/PersonalDataManagement";

const LandingPage: React.FC = () => {
  const { selectedCountry } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );
  const { userData, userCountryCode } = useSelector<
    ApplicationState,
    UserState
  >((state) => state.user);

  const { toggleLoginModal } = useLoginOptionHooks();
  const { hasLocalSite, countryCode } = useHub();
  const { setHideChangeLocationDrawer, removeSelectedCountry } = useLayout();
  //state
  const [isVisible, setIsVisible] = useState<boolean>(true);

  //SA COUNTRYCODE from userData
  const saCountry = userData.countryCode;
  const hasAccessLoginThruDeepLinked = localStorage.getItem(
    "hasAccessLoginThruDeepLinked"
  );

  const handleScrollOnClick = () => {
    const body = document.getElementById("main-body");
    const manage = document.getElementById("manage-privacy");
    body?.scrollTo({ top: manage?.offsetTop, behavior: "smooth" });
  };

  useEffect(() => {
    if (!userCountryCode || !saCountry) return;

    if (
      (userCountryCode !== TURKEY_COUNTRY_CODE ||
        (selectedCountry && selectedCountry.code !== TURKEY_COUNTRY_CODE)) &&
      saCountry === TURKEY_SA_COUNTRY_CODE &&
      hasLocalSite
    ) {
      setHideChangeLocationDrawer(true);
      removeSelectedCountry();

      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  }, [saCountry, hasLocalSite, countryCode, selectedCountry.code]);
  useEffect(() => {
    if (
      hasAccessLoginThruDeepLinked === "true" &&
      !UtilsUser.isUserLoggedIn()
    ) {
      toggleLoginModal({
        isLoginModalOpen: true,
        loginModalRedirect: ROUTES.ROOT,
      });
    }
    localStorage.removeItem("hasAccessLoginThruDeepLinked");
  }, [hasAccessLoginThruDeepLinked]);

  return (
    <>
      <Banner onClick={handleScrollOnClick} data-testid="landingPage-banner" />
      {isVisible && <ManagePrivacy />}
      <LearnMore />
      <PersonalDataManagement />
    </>
  );
};

export default LandingPage;
